import { get } from 'lodash';

// The product catalogue the screen manages, in display order. `demandNote` is not sold, so it is not
// offered; `rollingNote` has no rule row on purpose (the backend never checks a product without one) and
// the table says so instead of hiding the product.
export const PRODUCTS = [
  { type: 'creditFund', label: 'Credit Fund' },
  { type: 'individualNote', label: 'Individual Notes' },
  { type: 'constitutionNote', label: 'Constitution Notes' },
  { type: 'rollingNote', label: 'Rolling Note' },
];

export const PRODUCT_OPTIONS = PRODUCTS.map(({ type, label }) => ({ value: type, label }));

export const productLabel = (type) =>
  (PRODUCTS.find((product) => product.type === type) || { label: type }).label;

const money = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
});
export const fmtMoney = (n) => (n == null ? '—' : money.format(n));

// "Alex Rios", else the email. Works for a row of `adminInvestmentMinimums` and for an `AdminUser`.
export const personName = (person) =>
  `${person.firstName || ''} ${person.lastName || ''}`.trim() || person.email || '—';

// Backend errors are shown verbatim: the message IS the contract (it carries the numbers, e.g.
// "defaultAmount (10) cannot be below the lowest minimum (50)"). Apollo prefixes "GraphQL error: ".
export const backendMessage = (error) =>
  get(error, 'graphQLErrors[0].message') || error.message.replace(/^GraphQL error: /, '');

// Every write takes a reason: trimmed, 10-500 chars (the backend's MinLength/MaxLength after trim).
export const REASON_RULES = [
  { required: true, message: 'A reason is required' },
  {
    validator: (_, value) => {
      const length = (value || '').trim().length;
      if (length < 10) return Promise.reject(new Error('At least 10 characters'));
      if (length > 500) return Promise.reject(new Error('At most 500 characters'));
      return Promise.resolve();
    },
  },
];

// Thousands separators on the amount inputs (integer part only); the form value stays a number.
export const MONEY_INPUT = {
  style: { width: '100%' },
  prefix: '$',
  min: 0,
  precision: 2,
  formatter: (value) => {
    if (value === undefined || value === null || value === '') return '';
    const [integer, decimals] = `${value}`.split('.');
    const grouped = integer.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return decimals === undefined ? grouped : `${grouped}.${decimals}`;
  },
  parser: (value) => value.replace(/,/g, ''),
};
